import React, { useMemo } from "react";
import BarChartView from "../../../charts/BarChartView";

const SubjectWisePerformance = ({ data = {} }) => {
  const chartData = useMemo(() => {
    return Object.entries(data).map(([subject, value]) => ({
      name: subject === "unknown" ? "Others" : subject,
      percentage: Number(value.avgAccuracy.toFixed(2)),
    }));
  }, [data]);

  return <BarChartView data={chartData} />;
};

export default SubjectWisePerformance;
